import * as Actions from './type';
import * as EstimateAction from '../estimate/type';
import {
  createJobApi,
  generateROApi,
  getRepairOrders,
  getJobCardsApi,
  updateJobCardApi,
  getRoApi,
  getAuthorizationHistoryApi,
  updateROApi,
  deleteRoApi,
  commentsListApi,
  createCommentApi,
  replyApi,
  updateCommentApi,
  deleteCommentApi,
  getMessagesApi,
  sendMessageApi,
  addMediaAttachmentsApi,
  getMediaAttachmentsApi,
  shareRoPdfApi,
  getGeneralInfoApi,
  updateSidebarDataApi,
  getPurchasesApi,
  getInspectionPdfDataApi,
  getCustomerStats,
  updateRoStageApi,
} from '../../api/repairOrder/ro-api';

export const createJob = (ro) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.CREATE_RO_JOB_REQUEST,
      problemType: ro?.problemType, // for diffrentiate loader
    });

    const { data } = await createJobApi(ro);

    dispatch({
      type: Actions.CREATE_RO_JOB_SUCCESS,
      payload: data,
    });
    if (ro?.isDelete) {
      dispatch({
        type: EstimateAction.UPDATE_ESTIMATE_JOB_LIST,
        payload: ro,
      });
    }
  } catch (error) {
    dispatch({
      type: Actions.CREATE_RO_JOB_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const generateRO = (ro) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GENERATE_RO_REQUEST,
    });

    const { data } = await generateROApi(ro);

    dispatch({
      type: Actions.GENERATE_RO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GENERATE_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getRoListing = (query) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_RO_LISTING_REQUEST,
    });

    const { data } = await getRepairOrders(query);

    dispatch({
      type: Actions.GET_RO_LISTING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_RO_LISTING_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAuthorizationHistory = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_AUTHORIZATION_HISTORY_REQUEST,
    });

    const { data } = await getAuthorizationHistoryApi(roId);

    dispatch({
      type: Actions.GET_AUTHORIZATION_HISTORY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_AUTHORIZATION_HISTORY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getRepairOrder = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_RO_REQUEST,
    });

    const { data } = await getRoApi(id);

    dispatch({
      type: Actions.GET_RO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getInspectionPdfData = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_INSPECTION_PDF_DATA_REQUEST,
    });
    const { data } = await getInspectionPdfDataApi(roId);
    dispatch({
      type: Actions.GET_INSPECTION_PDF_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_INSPECTION_PDF_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getViewRepairOrder = (data) => async (dispatch) => {
  dispatch({
    type: Actions.GET_RO_SUCCESS,
    payload: data,
  });
};

export const updateRO = (roData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_RO_REQUEST,
    });

    const { data } = await updateROApi(roData);

    dispatch({
      type: Actions.UPDATE_RO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteRO = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_RO_REQUEST,
    });
    const { data } = await deleteRoApi(roId);
    dispatch({
      type: Actions.DELETE_RO_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// for estimate sidebar
export const getGeneralInfo = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_GENERAL_INFO_REQUEST,
    });

    const { data } = await getGeneralInfoApi(roId);

    dispatch({
      type: Actions.GET_GENERAL_INFO_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_GENERAL_INFO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateSidebarAction = (sidebarData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_SIDEBAR_REQUEST,
    });

    const { data } = await updateSidebarDataApi(sidebarData);

    dispatch({
      type: Actions.UPDATE_SIDEBAR_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_SIDEBAR_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const inspectionListUpdate = (data) => async (dispatch) => {
  dispatch({
    type: Actions.INSPECTION_LIST_UPDATE,
    payload: data,
  });
};

export const inspectionDeleteFromListOnUpdate = (id) => async (dispatch) => {
  dispatch({
    type: Actions.INSPECTION_DELETE_FROM_LIST,
    payload: id,
  });
};

export const techRecommendationDeleteFromListOnUpdate =
  (id) => async (dispatch) => {
    dispatch({
      type: Actions.TECH_RECOMMENDATION_DELETE_FROM_LIST,
      payload: id,
    });
  };

export const techRecommendationListUpdate = (data) => async (dispatch) => {
  dispatch({
    type: Actions.TECH_RECOMMENDATION_LIST_UPDATE,
    payload: data,
  });
};

export const getAllComments = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_ALL_COMMENTS_REQUEST,
    });
    const { data } = await commentsListApi(roId);
    dispatch({
      type: Actions.GET_ALL_COMMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_ALL_COMMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createComment = (comment) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.CREATE_COMMENT_REQUEST,
    });
    const { data } = await createCommentApi(comment);
    dispatch({
      type: Actions.CREATE_COMMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.CREATE_COMMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateComment = (comment) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_COMMENT_REQUEST,
    });
    const { data } = await updateCommentApi(comment);
    dispatch({
      type: Actions.UPDATE_COMMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_COMMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendCommentReply = (msg) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEND_REPLY_REQUEST,
    });
    const { data } = await replyApi(msg);
    dispatch({
      type: Actions.SEND_REPLY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEND_REPLY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateCommentReply = (msg) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_REPLY_REQUEST,
    });
    const { data } = await updateCommentApi(msg);
    dispatch({
      type: Actions.UPDATE_REPLY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_REPLY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteComment = (commentId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_COMMENT_REQUEST,
    });
    const { data } = await deleteCommentApi(commentId);
    dispatch({
      type: Actions.DELETE_COMMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_COMMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const deleteReply = (commentId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.DELETE_REPLY_REQUEST,
    });
    const { data } = await deleteCommentApi(commentId);
    dispatch({
      type: Actions.DELETE_REPLY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.DELETE_REPLY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAllMessages = (roId, messageType) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_ALL_MESSAGES_REQUEST,
    });
    const { data } = await getMessagesApi(roId, messageType);
    dispatch({
      type: Actions.GET_ALL_MESSAGES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_ALL_MESSAGES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendMessage = (msg) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEND_MESSAGE_REQUEST,
    });
    const { data } = await sendMessageApi(msg);
    dispatch({
      type: Actions.SEND_MESSAGE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEND_MESSAGE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAllEmails = (roId, messageType) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_ALL_EMAIL_REQUEST,
    });
    const { data } = await getMessagesApi(roId, messageType);
    dispatch({
      type: Actions.GET_ALL_EMAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_ALL_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendEmail = (msg) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEND_EMAIL_REQUEST,
    });
    const { data } = await sendMessageApi(msg);
    dispatch({
      type: Actions.SEND_EMAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEND_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const sendReply = (msg) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEND_EMAIL_REQUEST,
    });
    const { data } = await sendMessageApi(msg);
    dispatch({
      type: Actions.SEND_EMAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEND_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const addMediaAttachments = (data) => {
  return addMediaAttachmentsApi(data);
};

export const getMediaAttachments = (roId) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_MEDIA_ATTACHMENTS_REQUEST,
    });
    const { data } = await getMediaAttachmentsApi(roId);
    dispatch({
      type: Actions.GET_MEDIA_ATTACHMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_MEDIA_ATTACHMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const shareRoPdf = (obj) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SHARE_RO_PDF_REQUEST,
    });
    const { data } = await shareRoPdfApi(obj);
    dispatch({
      type: Actions.SHARE_RO_PDF_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SHARE_RO_PDF_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const clearShareRoPdfState = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_SHARE_RO_PDF_STATES });
};

export const geAllRoCards = () => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_RO_JOB_CARDS_REQUEST,
    });
    const { data } = await getJobCardsApi();
    dispatch({
      type: Actions.GET_RO_JOB_CARDS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_RO_JOB_CARDS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateRoCard = (item) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_RO_JOB_CARD_REQUEST,
    });
    const { data } = await updateJobCardApi(item);
    dispatch({
      type: Actions.UPDATE_RO_JOB_CARD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_RO_JOB_CARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getPurchases = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_PURCHASES_REQUEST,
    });

    const { data } = await getPurchasesApi(id);

    dispatch({
      type: Actions.GET_PURCHASES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_PURCHASES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const clearRoState = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_RO_STATES });
};

export const getRoCustomerStats = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_RO_REQUEST,
    });

    const {
      data: {
        data: { customerStats },
      },
    } = await getCustomerStats(id);
    console.log('customerStats', customerStats);
    dispatch({
      type: Actions.GET_CUSTOMER_STATS,
      payload: customerStats,
    });
    dispatch({ type: Actions.GET_RO_SUCCESS_LOADER_OFF });
  } catch (error) {
    dispatch({
      type: Actions.GET_RO_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateRoStage = (_data) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.UPDATE_RO_STAGE_REQUEST,
    });
    const { data } = await updateRoStageApi(_data);
    dispatch({
      type: Actions.UPDATE_RO_STAGE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_RO_STAGE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
